export default "__VITE_ASSET__bd23977f__"